import {
  IonIcon,
  useIonAlert,
  } from "@ionic/react";
import { GetPersonDetailsResponse } from "lemmy-js-client";
import {
  useCallback,
  useEffect,
  experimental_useEffectEvent as useEffectEvent,
  useState,
} from "react";

import { getUser } from "#/features/user/userSlice";
import { useBuildGeneralBrowseLink } from "#/helpers/routes";
import { useOptimizedIonRouter } from "#/helpers/useOptimizedIonRouter";
import { useAppDispatch } from "#/store";

import styles from './TopNavBar.module.css';
import { personCircleOutline } from "ionicons/icons";
import { Link } from "react-router-dom";
import { preventOnClickNavigationBug } from "#/helpers/ionic";
  
  interface TopNavBarProfileProps {
    handle: string;
  }
  
  export default function TopNavBarProfile({ handle }: TopNavBarProfileProps) {
    const buildGeneralBrowseLink = useBuildGeneralBrowseLink();
    const dispatch = useAppDispatch();
    const [person, setPerson] = useState<
      GetPersonDetailsResponse | "failed" | undefined
    >();
    const router = useOptimizedIonRouter();
    const [present] = useIonAlert();
  
    const load = useCallback(async () => {
      let data;
  
      try {
        data = await dispatch(getUser(handle));
      } catch (error) {
        setPerson("failed");
      }
  
      setPerson(data);
    }, [buildGeneralBrowseLink, dispatch, handle, present, router]);
  
    const loadEvent = useEffectEvent(load);
  
    useEffect(() => {
      if (handle) loadEvent();
    }, [handle]);

    let profileImgUrl;

    if (person && person !== 'failed') {
      profileImgUrl = person.person_view.person.avatar;
    }

    return (
      <Link
        to={`/profile`}
        onClick={(e) => {
          e.stopPropagation();
          preventOnClickNavigationBug(e);
        }}
        draggable={false}
      >
        <div className={styles.avatarTopBar}>
          {profileImgUrl ? (
            <img src={profileImgUrl} alt="Profile" className={styles.avatarImage} />
          ) : (
            <IonIcon icon={personCircleOutline} className={styles.avatarPlaceholder} />
          )}
        </div>
      </Link>
    );
  }
  